import React from "react";
import { cn } from "./utils";

const field =
  "tw-flex tw-h-9 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-1 tw-font-sans tw-text-sm tw-leading-5 tw-text-foreground tw-shadow-sm tw-transition-colors placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring/40 focus-visible:tw-border-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50";

export const Input = React.forwardRef(({ className, type = "text", invalid, ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    aria-invalid={invalid || undefined}
    className={cn(field, invalid && "tw-border-destructive focus-visible:tw-ring-destructive/40", className)}
    {...props}
  />
));
Input.displayName = "Input";

// A native select styled like the inputs: keyboard and screen-reader behaviour
// stay the browser's own.
export const NativeSelect = React.forwardRef(({ className, children, ...props }, ref) => (
  <div className={cn("tw-relative tw-inline-flex", className)}>
    <select
      ref={ref}
      className={cn(field, "tw-cursor-pointer tw-appearance-none tw-pr-8")}
      {...props}
    >
      {children}
    </select>
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="tw-pointer-events-none tw-absolute tw-right-2.5 tw-top-1/2 tw-size-4 -tw-translate-y-1/2 tw-text-muted-foreground"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  </div>
));
NativeSelect.displayName = "NativeSelect";
